import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import PullToRefresh from "react-simple-pull-to-refresh";

import {Button, IcoPlus, TitleH1, TitleH2} from "components/generic";

import {ContainerValue, ContainerView, CorrectPullRefresh, PullGrid,} from "components/containers";
import {MenuLeftSide} from "components/MenuLeftSide";
import {MainWrapper} from "pages/HostHouseRegistration/styles";
import {StyledDiv} from "./styles";
import {HOST_ROOMADD_ROUTE} from "utils/constants";
import {initialHouse, useContextHost} from "context/ContextHost";
import {RoomCard} from "./RoomCard";
import {HelpWidget} from "components/HelpWidget";
import {LoaderCustom} from "components/Loader";
import {theme} from "styles/theme";

export const HostRooms: React.FC = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("hostrooms");
  const { housesShotData, setCurrentHouse, getHousesShortData, loading } =
    useContextHost();

  useEffect(() => {
    setCurrentHouse(initialHouse);
  });

  useEffect(() => {
    getHousesShortData();
    // eslint-disable-next-line
  }, []);

  return (
    <ContainerView>
      <MenuLeftSide />
      <MainWrapper>
        {loading && <LoaderCustom size={5} color={theme.colors.bgBody} />}
        <CorrectPullRefresh>
          <PullToRefresh
            onRefresh={async () => getHousesShortData()}
            pullingContent={
              <LoaderCustom
                size={5}
                color={theme.colors.bgBody}
                text={t("textLoading.3")}
              />
            }
            className="pullRefresh  "
          >
            <PullGrid>
              <TitleH1>{t("dashboard.title")}</TitleH1>

              {housesShotData.length === 0 ? (
                <>
                  <StyledDiv>
                    <TitleH2 m="0 0 24px 0">
                      {t("dashboard.emptyArray.text")}
                    </TitleH2>
                    <Button
                      normal
                      onClick={() => navigate(`/${i18n.language}${HOST_ROOMADD_ROUTE.slice(5)}`)}
                    >
                      <IcoPlus size="1.5em" />
                      {" " + t("dashboard.emptyArray.buttonAdd")}
                    </Button>
                  </StyledDiv>
                  <HelpWidget
                    title={t("dashboard.textHelp.title")}
                    text={t("dashboard.textHelp.content").split(".")}
                    btnText={t("dashboard.buttonHelp")}
                  />
                </>
              ) : (
                <>
                  {housesShotData
                    .filter((item) => item.house_status !== "ARCHIVED")
                    .map((room) => (
                      <RoomCard
                        house={
                          room.house_status === "RENTED"
                            ? { ...room, published_at: "" }
                            : room
                        }
                        key={room.house_id}
                      />
                    ))}
                  <ContainerValue
                    style={{ padding: "24px", marginBottom: "24px" }}
                  >
                    <Button
                      normal
                      onClick={() => {
                        setCurrentHouse(initialHouse);
                        navigate(`/${i18n.language}${HOST_ROOMADD_ROUTE.slice(5)}`);
                      }}
                      w="100%"
                    >
                      <IcoPlus size="1.5em" />
                      {" " + t("dashboard.emptyArray.buttonAdditionalRoom")}
                    </Button>
                  </ContainerValue>
                </>
              )}
            </PullGrid>
          </PullToRefresh>
        </CorrectPullRefresh>
      </MainWrapper>
    </ContainerView>
  );
};
